import { Type } from '@angular/core';

export class UCItem {
  constructor(public component: Type<any>, public data: any) {}
}